module.exports = __webpack_public_path__ + "static/img/11.4f97c45.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/sp/11.png
// module id = 6qqX
// module chunks = 0